<template>
  <v-card class="gallery-view--hykecam">
    <gallery-view-toolbar
      :editable="editable"
      :event="event"
      :sensorType="sensorType"
      :canDownload="canDownload"
      :title="title"
      @download="download"
      @update="(attr) => $emit('updateEvent', attr)"
      @close="$emit('close')">
    </gallery-view-toolbar>
    <layout
      :hasPrevious="hasPrevious"
      :hasNext="hasNext"
      @previous="$emit('previous')"
      @next="$emit('next')"
    >
      <template #top>
        <gallery-view-header
          :editable="editable"
          :event="event"
          @updateEvent="$emit('updateEvent', $event)"
        />
      </template>
      <div>
        <div class="media mb-2">
          <event-video
            :src="event.attachments.video"
            :thumbnail="event.attachments.thumbnail"
            v-if="resourceType === 'video'"
          />
          <loading-image :src="imageUrl" v-else/>
        </div>
        <slot name="thumbnails" />
      </div>
    </layout>
  </v-card>
</template>

<script>
import LoadingImage from '@/components/LoadingImage';
import EventVideo from '@/components/GalleryView/EventVideo';
import GalleryViewToolbar from '@/components/GalleryView/Toolbar';
import Layout from '@/components/GalleryView/Layout';
import GalleryViewHeader from '@/components/GalleryView/GalleryViewHeader';

export default {
  name: 'HykecamView',
  props: {
    editable: Boolean,
    event: Object,
    sensorType: String,
    hasPrevious: Boolean,
    hasNext: Boolean,
    title: String,
  },
  inject: ['downloadAttachment'],
  components: {
    EventVideo,
    GalleryViewHeader,
    GalleryViewToolbar,
    Layout,
    LoadingImage,
  },
  computed: {
    imageUrl() {
      return this.event.attachments.photo;
    },
    resourceType() {
      if (this.event.attachments.video) {
        return 'video';
      }
      return 'photo';
    },
    canDownload() {
      return !this.event.updating && !!this.event.attachments[this.resourceType];
    },
  },
  methods: {
    download: async function () {
      this.downloadAttachment(this.event.id, this.resourceType);
    },
  },
};
</script>

<style scoped lang="sass">
@import 'vuetify/src/styles/styles.sass'

.media
  @media #{map-get($display-breakpoints, 'md-and-up')}
    max-width: 64%
    margin: 0 auto

  .loading-image,
  .event-video
    @media #{map-get($display-breakpoints, 'md-and-up')}
      max-width: 80%
      margin: 0 auto
</style>
